import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const SettingsRoutes: RouteObject = {
	path: "settings/*",
	lazy: async () => {
		const { SettingsHome } = await import(
			"@/components/Application/AdminMenu/Settings/SettingsHome"
		);
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={({ error, componentStack, resetError }) => (
						<PageError
							error={error}
							componentStack={componentStack}
							reset={resetError}
						/>
					)}
				>
					<SettingsHome />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		{
			index: true,
			lazy: async () => {
				const { SettingsHome } = await import(
					"@/components/Application/AdminMenu/Settings/SettingsHome"
				);
				return {
					Component: SettingsHome,
				};
			},
		},
		{
			path: "language/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { LanguageSettings } = await import(
							"@/components/Application/AdminMenu/Settings/LanguageSettings/LanguageSettings"
						);
						return { Component: LanguageSettings };
					},
				},
				{
					path: "create-new",
					children: [
						{
							index: true,
							lazy: async () => {
								const { CreateNewLanguageSetting } = await import(
									"@/components/Application/AdminMenu/Settings/LanguageSettings/CreateNewLanguageSetting"
								);
								return { Component: CreateNewLanguageSetting };
							},
						},
					],
				},
			],
		},
	],
};
